import backendURLs from '~/misc/backendURLs';

export default (axios, payload) => {
  return axios
    .post(backendURLs.checkout, payload)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
